export default "__VITE_ASSET__BkKr7XXP__"